module.exports = __webpack_public_path__ + "img/mobile-banner0-ja.48e21663.jpg";